import React from "react";
import "../../assets/css/homepage.css";
import { Link } from "react-router-dom";

export default function RunningCard({ runnig, winnAmount, game_type }) {
  const user = localStorage.getItem("userId");

  const creatorName = runnig?.Created_by?.Name
    ? runnig.Created_by.Name.length > 8
      ? `${runnig.Created_by.Name.slice(0, 8)}..`
      : runnig.Created_by.Name
    : "Player 1";

  const acceptorName = runnig?.Accepetd_By?.Name
    ? runnig.Accepetd_By.Name.length > 8
      ? `${runnig.Accepetd_By.Name.slice(0, 8)}..`
      : runnig.Accepetd_By.Name
    : "Player 2";

  const isParticipant =
    user == runnig?.Accepetd_By?._id || user == runnig?.Created_by?._id;

  const prizeAmount =
    (runnig?.Game_Ammount || 0) +
    (winnAmount ? winnAmount(runnig?.Game_Ammount || 0) : 0);

  return (
    <div className="hp_running_match_card">
      <div className="hp_running_vs_pill">
        <span className="hp_run_player_name">{creatorName}</span>
        <span className="hp_run_vs_tag">VS</span>
        <span className="hp_run_player_name">{acceptorName}</span>
      </div>

      <div className="hp_running_bottom_row">
        <div className="hp_stake_column">
          <span className="hp_stake_micro_label">Entry Fee</span>
          <span className="hp_stake_big_value">₹ {runnig?.Game_Ammount}</span>
        </div>

        <div>
          {isParticipant ? (
            <Link
              className={`hp_btn_view_emerald ${
                runnig?.Status === "conflict" ? "is_conflict" : ""
              }`}
              to={{
                pathname: `/viewgame/${runnig?._id}`,
                state: { prevPath: window.location.pathname },
              }}
            >
              {runnig?.Status === "conflict" ? "Conflict" : "VIEW >"}
            </Link>
          ) : (
            <img
              src={process.env.PUBLIC_URL + "/images/Homepage/versus.png"}
              alt="VS"
              style={{ width: "24px", height: "auto" }}
            />
          )}
        </div>

        <div className="hp_stake_column" style={{ textAlign: "right" }}>
          <span className="hp_stake_micro_label">Prize</span>
          <span className="hp_stake_big_value prize_text">
            <span className="hp_trophy_emoji">🏆</span>
            <span>{prizeAmount}</span>
          </span>
        </div>
      </div>
    </div>
  );
}
